import { combineReducers } from "redux";
import { AccessRequest, Property } from "src/common/types";

export default combineReducers({
  error: (state: boolean = false, action) => {
    switch (action.type) {
      case "GET_PROPERTY_DATA_SUCCESS":
        return false;
      case "GET_PROPERTY_DATA_ERROR":
      case "GET_PROPERTY_DATA_FAILURE":
        return true;
      default:
        return state;
    }
  },
  loading: (state: boolean = false, action) => {
    switch (action.type) {
      case "GET_PROPERTY_DATA_REQUEST":
        return true;
      case "GET_PROPERTY_DATA_SUCCESS":
      case "GET_PROPERTY_DATA_FAILURE":
        return false;
      default:
        return state;
    }
  },
  loaded: (state: boolean = false, action) => {
    switch (action.type) {
      case "GET_PROPERTY_DATA_SUCCESS":
        return true;
      default:
        return state;
    }
  },
  meta: (state: Property | null = null, action) => {
    switch (action.type) {
      case "GET_PROPERTY_DATA_SUCCESS":
        return action.json.property as Property;
      case "GET_PROPERTY_DATA_ERROR":
        if (action.error?.response?.status === 404) {
          return null;
        }
        return state;
      default:
        return state;
    }
  },
  residents: (state = null, action) => {
    switch (action.type) {
      case "GET_PROPERTY_DATA_SUCCESS":
        return action.json.residents;
      default:
        return state;
    }
  },
  staff: (state = null, action) => {
    switch (action.type) {
      case "GET_PROPERTY_DATA_SUCCESS":
        return action.json.property_staff;
      default:
        return state;
    }
  },
  unitGuests: (state = null, action) => {
    switch (action.type) {
      case "GET_PROPERTY_DATA_SUCCESS":
        return action.json.unitGuests;
      default:
        return state;
    }
  },
  propertyGuests: (state = null, action) => {
    switch (action.type) {
      case "GET_PROPERTY_DATA_SUCCESS":
        return action.json.property_guests;
      default:
        return state;
    }
  },
  device: (state = null, action) => {
    switch (action.type) {
      case "GET_PROPERTY_DATA_SUCCESS":
        return action.json.device;
      default:
        return state;
    }
  },
  accessRequests: (state: AccessRequest[] = [], action) => {
    switch (action.type) {
      case "ENQUEUE_ACCESS_REQUEST":
        return [...state, action.accessRequest];
      case "SEND_ACCESS_REQUESTS_SUCCESS":
        return state.filter(
          (accessRequest: AccessRequest) =>
            !action.accessRequests.find(
              (item: AccessRequest) =>
                accessRequest.user_code === item.user_code &&
                accessRequest.created_at === item.created_at &&
                accessRequest.access_granted === item.access_granted
            )
        );
      default:
        return state;
    }
  },
  areAccessRequestsSending: (state: boolean = false, action) => {
    switch (action.type) {
      case "SEND_ACCESS_REQUESTS_REQUEST":
        return true;
      case "SEND_ACCESS_REQUESTS_SUCCESS":
      case "SEND_ACCESS_REQUESTS_FAILURE":
      case "SEND_ACCESS_REQUESTS_ERROR":
        return false;
      default:
        return state;
    }
  },
});
